import { Button } from "@carrotfertility/carotene-core"
import React from "react"
import { useUserRole } from "#/components/partner-access/hooks/usePartnerAccess"
import { FormattedMessage } from "react-intl"

export function CommunicationPreferencesButton({ isForPartner }: { isForPartner?: boolean }): JSX.Element {
  const { isPartnerAccessingAccount } = useUserRole()

  const disabled = (isForPartner && !isPartnerAccessingAccount) || (!isForPartner && isPartnerAccessingAccount)

  return (
    <Button
      variant="outlined"
      color="inherit"
      href="/communication-preferences-redirect"
      target="_blank"
      rel="noopener noreferrer"
      sx={{ alignSelf: "flex-start" }}
      disabled={disabled}
    >
      <FormattedMessage defaultMessage="Update Preferences" />
    </Button>
  )
}
